import { useTranslations } from 'next-intl';
import {
  PRIVACY_POLICY_URL,
  TERMS_OF_SERVICE_URL,
} from '@/constants/external-urls';

export function Footer() {
  const t = useTranslations('referrals');

  return (
    <footer className="text-sm text-subtle px-10 pb-2 sm:px-0 sm:pb-0">
      {t.rich('footer', {
        'terms-link': (chunks) => (
          <a
            className="text-primary underline"
            href={TERMS_OF_SERVICE_URL}
            target="_blank"
            rel="noreferrer"
            tabIndex={-1}
          >
            {chunks}
          </a>
        ),
        'privacy-link': (chunks) => (
          <a
            className="text-primary underline"
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noreferrer"
            tabIndex={-1}
          >
            {chunks}
          </a>
        ),
      })}
    </footer>
  );
}
